import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getCurrencies = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get("/lookups/currencies");
    const currencies = res.data.data;
    if (currencies) {
      localStorage.setItem("currencies", JSON.stringify(currencies));
    }
    dispatch({ type: CommonActionTypes.GET_CURRENCIES, payload: currencies });
    return currencies;
  } catch (err) {
    const message = err.response.data.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};

// Fireblocks
export const getCryptoCurrencies = () => async (dispatch) => {
  try {
    const res = await commonService.get("/client/crypto-management/currencies");
    const network = res.data.data;

    return network;
  } catch (err) {
    const message = err.response.data.message || err.message;

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return err.response.data;
  } 
};
